// removed by extract-text-webpack-plugin
module.exports = {"description":"_20WXSW1fEVgAUx_131TRsk","processNavbar":"wyK0TQrOL0MIkLb1yaCOs","queryDataList":"_1R8AnhkMVnZFy14_43rgWS","userDataList":"_2uEONPEktwuYrBkgA_2NL5","queryStatus":"_15AefHE1cbUXoVFWVSMrxU","userPhoto":"tZRLfqeEj5V0ZMBEVP8hI","exclamation":"_2lipA5m-aYBletuzKIoPJ8","text":"QkNoX0q2kV5bYsTmQomQ1","textEmail":"_2oAtry_qv9AzHe2YH8CvWl"};


//////////////////
// WEBPACK FOOTER
// ./components/Subscriptions/styles.less
// module id = 1494
// module chunks = 0